import { FormField, Radio, RadioLabelSize } from '@revelio/ui';

import type { DeliveryFormat } from '../../data-builder.store';

const formatOptions: { value: DeliveryFormat; label: string }[] = [
  { value: 'csv', label: 'CSV' },
  { value: 'parquet', label: 'Parquet' },
  { value: 'excel', label: 'Excel' },
];

type DeliveryFormatRadiosProps = {
  name: string;
  label?: string;
  value: DeliveryFormat;
  onChange: (format: DeliveryFormat) => void;
};

export const DeliveryFormatRadios = ({
  name,
  label = 'File Format',
  value,
  onChange,
}: DeliveryFormatRadiosProps) => (
  <FormField label={label}>
    <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
      {formatOptions.map((option) => (
        <Radio
          key={option.value}
          name={name}
          label={option.label}
          checked={value === option.value}
          onChange={() => {
            if (value === option.value) {
              return;
            }
            onChange(option.value);
          }}
          data-testid={`data-builder-delivery-format-${option.value}`}
          size={RadioLabelSize.SM}
        />
      ))}
    </div>
  </FormField>
);

export const DEFAULT_REMOTE_DELIVERY_FORMAT: DeliveryFormat = 'parquet';
